var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"alternative-departure__item",on:{"click":function($event){return _vm.$emit('change', {name: _vm.name, id: _vm.id})}}},[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }